import { render, staticRenderFns } from "./PropertyListHome.vue?vue&type=template&id=08ea9a17&scoped=true&"
import script from "./PropertyListHome.vue?vue&type=script&lang=js&"
export * from "./PropertyListHome.vue?vue&type=script&lang=js&"
import style0 from "./PropertyListHome.vue?vue&type=style&index=0&id=08ea9a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea9a17",
  null
  
)

export default component.exports